import type { Thread } from "../../../types";
import type { ComposerModelSelection } from "../useComposerModelSelection";
import { useComposerUsageNotice } from "./composerUsageNotice";

interface UsageNoticePendingState {
  readonly activePendingApproval: { readonly requestId: string } | null;
}

interface UsageNoticePendingInput {
  readonly activePendingUserInput: { readonly requestId: string } | null;
  readonly activePendingProgress: {
    readonly activeQuestion: { readonly id: string } | null;
  } | null;
}

export function useChatComposerUsageNotice(input: {
  readonly threadId: string;
  readonly composerModelSelection: ComposerModelSelection;
  readonly activeThread: Thread | undefined;
  readonly latestTurnId: string | null;
  readonly activity: UsageNoticePendingState;
  readonly pendingInput: UsageNoticePendingInput;
}) {
  return useComposerUsageNotice({
    threadId: input.threadId,
    modelSelection: input.composerModelSelection.modelSelection,
    rateLimitStatus: input.activeThread?.rateLimitStatus,
    latestTurnId: input.latestTurnId,
    pendingInputId: currentUsageNoticePendingInputId(input.activity, input.pendingInput),
  });
}

function currentUsageNoticePendingInputId(
  activity: UsageNoticePendingState,
  pendingInput: UsageNoticePendingInput,
): string | null {
  return (
    activity.activePendingApproval?.requestId ??
    pendingInput.activePendingUserInput?.requestId ??
    pendingInput.activePendingProgress?.activeQuestion?.id ??
    null
  );
}
